import script from "./InvitePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitePage.vue?vue&type=script&setup=true&lang=js"

export default script